import {
  getAccountNumberColumn,
  getBalanceUpdatedColumn,
  getBankColumn,
  getCurrencyColumn,
  getTotalBalanceColumn,
  getWalletBalanceColumn,
  getWalletUpdatedColumn,
} from "./accountColumnHelpers";

export function accountColumns() {
  return [
    getBankColumn(),
    getAccountNumberColumn(),
    getCurrencyColumn(),
    getTotalBalanceColumn(),
    getWalletBalanceColumn(),
    getBalanceUpdatedColumn(),
    getWalletUpdatedColumn(),
  ];
}